import { render, staticRenderFns } from "./contractV2.vue?vue&type=template&id=e68e3bdc&scoped=true"
import script from "./contractV2.vue?vue&type=script&lang=js"
export * from "./contractV2.vue?vue&type=script&lang=js"
import style0 from "./contractV2.vue?vue&type=style&index=0&id=e68e3bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68e3bdc",
  null
  
)

export default component.exports